import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  // Base:
  // - rounded-full: Visual moderno tipo "pill"
  // - gap-1.5: Espaçamento perfeito se houver ícone + texto
  // - font-medium: Leitura um pouco melhor que font-semibold para status longos
  "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",

        // OUTLINE (Crucial para o seu StatusBadge):
        // Define uma borda base sutil. Se o seu mapa passar "border-amber-200",
        // o `cn` vai substituir este "border-input".
        outline: "border-border text-foreground",

        // Mantive estes para uso fora dos mapas, se precisar
        success: "border-transparent bg-green-600 text-white hover:bg-green-700",
        warning: "border-transparent bg-amber-500 text-white hover:bg-amber-600",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

// forwardRef pelo mesmo motivo do Button: Badge é usado dentro de `TooltipTrigger asChild`.
const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => (
    <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
  ),
);
Badge.displayName = "Badge";

export { Badge, badgeVariants };
